export default __webpack_public_path__ + "static/media/frame2.4e9e8b6c.PNG";